var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ll-card"},[_c('div',{staticClass:"ll-card__header"},[_c('div',{staticClass:"ll-card__header__title"},[(_vm.$slots['title'])?[_vm._t("title")]:[_vm._v(_vm._s(_vm.title))]],2),_vm._t("header-extra-content")],2),_c('div',{staticClass:"ll-card__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }